<template>
  <div class="tn-travel-finder">
    <div class="flex-row">
      <div class="flex-row">
        <div class="flex-row">
          <div id="dr-picker" class="flex-row">
            <div class="input-wrapper">
              <input type="text"
                     ref="date_range_start"
                     id="date_range_start"
                     placeholder="Von"
                     autocomplete="off"
                     class="range-input"
                     :value="this.date_range[0]"
                     @click="selectDateRangeStart"
                     style="flex: 1 1 0px;"
              >
              <button type="button"
                      class="clear-input"
                      @click="clearDateRangeStart()"
              ><i class="eicon-editor-close"></i></button>
            </div>
            <div class="input-wrapper">
              <input type="text"
                     ref="date_range_end"
                     id="date_range_end"
                     placeholder="Bis"
                     autocomplete="off"
                     class="range-input"
                     :value="this.date_range[1]"
                     @click="selectDateRangeEnd"
                     style="flex: 1 1 0px;"
              >
              <button type="button"
                      class="clear-input"
                      @click="clearDateRangeEnd()"
              ><i class="eicon-editor-close"></i></button>
            </div>

            <DrPicker ref="drPicker" @update:range="updateDateRange($event)" />
          </div>
          <div style="width: 100%;"><input type="text"
                                           v-model="search"
                                           class="filter-search"
                                           @keyup="findOnEnter"
                                           placeholder="Freitextsuche, Reisecode oder Text eingeben"

          ></div>
          <v-select placeholder="Reiseart wählen"
                    label="name"
                    multiple
                    :reduce="term => term.slug"
                    :options="facets.means_of_travel"
                    v-model="means_of_travel"
          ></v-select>
          <v-select placeholder="Reiseziel wählen"
                    label="name"
                    multiple
                    :reduce="term => term.slug"
                    :options="facets.travel_destination"
                    v-model="travel_destination"
          ></v-select>
          <v-select placeholder="Reiseform wählen"
                    label="name"
                    multiple
                    :reduce="term => term.slug"
                    :options="facets.type_of_travel"
                    v-model="type_of_travel"
          ></v-select>
        </div>
      </div>
      <div class="btn-wrapper">
        <button type="button" @click="find()" class="btn-find">Jetzt finden</button>
      </div>
    </div>
  </div>
</template>

<script>

import DrPicker from "../DrPicker";
import {formatDate} from "../helper/date";
export default {
  name: "TnTravelFinder",
  components: {DrPicker},
  props: {
    result_page_url: String,
    facets: Object
  },
  data: () => ({
    search: "",
    date_range: [
        null, null
    ],
    type_of_travel: [],
    means_of_travel: [],
    travel_feature: [],
    travel_destination: [],
    travel_country: [],
    travel_region: [],
    travel_city: [],
  }),
  computed: {
    filter() {
      const filter = {
        search: this.search,
        date_range: this.date_range,
      };
      Object.keys(this.facets)
          .forEach((facet) => {
            if (this[facet]) {
              filter[facet] = this[facet];
            }
          });

      return filter;
    }
  },
  methods: {

    selectDateRangeStart() {
      this.$refs.date_range_start.blur();
      this.$refs.drPicker.show({
        mode: 'range-start',
        range: {
          start: this.$refs.drPicker.parseDate(this.$refs.date_range_start.value),
          end: this.$refs.drPicker.parseDate(this.$refs.date_range_end.value)
        }
      });
    },

    clearDateRangeStart() {
      this.$refs.date_range_end.blur();
      const dateRange = this.date_range.slice();
      dateRange[0] = formatDate(new Date());

      this.date_range = dateRange;
    },

    selectDateRangeEnd() {
      this.$refs.date_range_end.blur();
      this.$refs.drPicker.show({
        mode: 'range-end',
        range: {
          start: this.$refs.drPicker.parseDate(this.$refs.date_range_start.value),
          end: this.$refs.drPicker.parseDate(this.$refs.date_range_end.value)
        }
      });
    },

    clearDateRangeEnd() {
      const dateRange = this.date_range.slice();
      dateRange[1] = null;

      this.date_range = dateRange;
    },

    updateDateRange(range) {
      this.date_range = [
          this.$refs.drPicker.formatDate(range.start),
          this.$refs.drPicker.formatDate(range.end)
      ];
      this.$refs.date_range_start.value = this.$refs.drPicker.formatDate(range.start);
      this.$refs.date_range_end.value = this.$refs.drPicker.formatDate(range.end);
    },

    findOnEnter(e) {
      if (e.keyCode === 13 || e.keyCode === 10) {
        this.find();
      }
    },

    find() {
      const filter = this.filter;
      const url = new URL(this.result_page_url);
      url.searchParams.set('filter', JSON.stringify(filter));
      window.location = url.toJSON();
    }
  }
}
</script>

<style lang="scss">
  .tn-travel-finder {
    $vs-state-active-bg: #910A0A;
    @import '../../node_modules/vue-select/src/scss/vue-select';

    .v-select {
      flex: 1 1 0px;
    }

    .v-select > * {
      color: #666;
      padding: .75em;
      height: auto;
      border-width: 1px;
      border-style: solid;
      border-color: #eaeaea;
      border-radius: 2px;
      background: #fafafa;
      box-shadow: none;
      box-sizing: border-box;
      transition: all .2s linear;
    }

    .vs__search,
    .vs__search:focus,
    .vs__selected {
      margin-top: 0;
    }

    .vs__deselect,
    .vs__deselect:hover,
    .vs__deselect:focus {
      fill: #fff;
      color: #000000;
      background-color: transparent;
    }

    .vs__selected {
      margin: 0;
      background-color: #206b2d;
      border-color: #206b2d;
      color: #fff;
    }

    .vs__selected-options {
      display: flex;
      flex-basis: 100%;
      flex-grow: 1;
      flex-wrap: wrap;
      padding: 0px;
      position: relative;
      margin: 5px 5px;
    }

    .flex-row {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      margin-top: -15px;
      margin-left: -15px;
    }

    .flex-row > * {
      flex: 1 1 auto;
      margin-top: 15px;
      margin-left: 15px;
    }

    .flex-row > .flex-row {
      margin-left: 0;
      margin-top: 0;
    }

    &>.flex-row {
      flex-wrap: nowrap;
    }

    .filter-search {
      width: 100%;
    }

    #dr-picker {
      display: flex;
      position: relative;
      width: 250px;
    }

    .input-wrapper {
      position: relative;
      flex: 1 1 0px;

      input {
        padding-right: 32px;
        width: 100%;
      }

      & > .clear-input {
        background: transparent;
        color: #9b9b9b;
        position: absolute;
        top: 0px;
        right: 0px;
        height: 100%;
        width: 32px;
        padding: 0px;
        margin: 0;

        display: flex;
        align-items: center;
        justify-content: center;

        &>i {
          font-size: 1.8em;
        }
      }
    }

    .btn-wrapper {
      flex: 0 0 auto;
      align-self: flex-end;
    }
    .btn-find {
      color: #fff;
    }
  }

  @media screen and (max-width: 921px) {
    .tn-travel-finder {
      & > .flex-row {
        flex-wrap: wrap;
      }

      #dr-picker {
        width: 100%;
      }

      .btn-wrapper {
        flex: 0 0 auto;
        align-self: flex-end;
      }

      .btn-find {
        width: 100%;
      }
    }
  }

  @media screen and (max-width: 576px) {
    .tn-travel-finder {
      & > .flex-row {
        flex-wrap: wrap;
      }

      .v-select {
        width: 100%;
        flex-basis: auto;
      }

      #dr-picker {
        width: 100%;
      }

      .btn-wrapper {
        flex: 0 0 auto;
        align-self: flex-end;
        width: calc(100% - 15px);
      }

      .btn-find {
        width: 100%;
      }
    }
  }
</style>
